/**
 * api-客户信息
 */
import { post } from '@/utils/http'
// 获取基本用户的列表
export const apiGetBUserList = p => post('/BUser/getBUserList.do', p)
export const apiUpdateBUser = p => post('/BUser/updateBUser.do', p)
// 获取在线预约列表
export const apiGetAppointmentOnlineList = p =>
  post('/BUser/getAppointmentOnlineList.do', p)
// 获取今日签到列表
export const apiSignList = p => post('/BUser/signList.do', p)
// 获取用户的成员信息
export const apiGetMemberListByUid = p => post('/BUser/getMemberListByUid.do', p)
// 获取预警的详细信息
export const apiGetEarlyDetaild = p => post('/BUser/getEarlyDetail.do', p)
// 获取所有小程序用户
export const apiGetAppletList = p => post('/BUser/getAppletList.do', p)




// 获取报告
export const apiGetReport = p => post('/report/getReport.do', p)
export const apiGetReportDtl = p => post('/report/getReportDtl.do', p)
export const apiGetReportPage = p => post('/report/getReportPage.do', p)
export const apiUpdateReport = p => post('/report/updateReport.do', p)
export const apiDeleteReport = p => post('/report/deleteReport.do', p)
// 获取报告2
export const apiGetReportSimple = p => post('/reportSimple/getReportSimple.do', p)
export const apiGetReportSimpleDtl = p => post('/reportSimple/getReportSimpleDtl.do', p)
export const apiGetReportSimplePage = p => post('/reportSimple/getReportSimplePage.do', p)
export const apiUpdateReportSimple = p => post('/reportSimple/updateReportSimple.do', p)
export const apiDeleteReportSimple = p => post('/reportSimple/deleteReportSimple.do', p)
// 获取报告模板
export const apiGetReportTmpl = p => post('/report/getReportTmpl.do', p)
export const apiAddReportTmpl = p => post('/report/addReportTmpl.do', p)
export const apiUpdateReportTmpl = p => post('/report/updateReportTmpl.do', p)

// 随访记录
export const apiGetAccessRecord = p => post('/accessRecord/getAccessRecord.do', p)
export const apiGetAccessRecordPage = p => post('/accessRecord/getAccessRecordPage.do', p)
export const apiAddAccessRecord = p => post('/accessRecord/addAccessRecord.do', p)
export const apiUpdateAccessRecord = p => post('/accessRecord/updateAccessRecord.do', p)
export const apiDeleteAccessRecord = p => post('/accessRecord/deleteAccessRecord.do', p)

// 健管方案
export const apiGetScheme = p => post('/scheme/getScheme.do', p)
export const apiGetSchemeDtl = p => post('/scheme/getSchemeDtl.do', p)
export const apiGetSchemePage = p => post('/scheme/getSchemePage.do', p)
export const apiUpdateScheme = p => post('/scheme/updateScheme.do', p)
export const apiDeleteScheme = p => post('/scheme/deleteScheme.do', p)

// 每日管理
export const apiGetTodayRecord = p => post('/today/getTodayRecordDtl.do', p)
export const apiGetTodayRecordPage = p => post('/today/getTodayRecordPage.do', p)
export const apiAddTodayRecord = p => post('/today/addTodayRecord.do', p)
export const apiUpdateTodayRecord = p => post('/today/updateTodayRecord.do', p)
export const apiDeleteTodayRecord = p => post('/today/deleteTodayRecord.do', p)
export const apiGetTodayLog = p => post('/today/getTodayLog.do', p)

// 疗愈生活
export const apiGetHealing = p => post('/healing/getHealing.do', p)
export const apiGetHealingDtl = p => post('/healing/getHealingDtl.do', p)
export const apiGetHealingPage = p => post('/healing/getHealingPage.do', p)
export const apiUpdateHealing = p => post('/healing/updateHealing.do', p)
export const apiDeleteHealing = p => post('/healing/deleteHealing.do', p)